import { ROUTES } from '@/constants/routes';
import { usePermissions } from '@/contexts/PermissionsContext';
import { TagIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

/**
 * Icône « Promotions du site » de l'en-tête (à côté de celles des messages et des demandes SAV).
 * N'est rendue que pour les rôles disposant de la permission 'promotions_site'. Aucune requête.
 */
export function PromotionsSiteButton() {
  const navigate = useNavigate();
  const { hasPermission, isLoading } = usePermissions();

  if (isLoading || !hasPermission('promotions_site')) return null;

  return (
    <button
      onClick={() => navigate(ROUTES.PROMOTIONS_SITE)}
      className="layout-header-btn-hover relative p-2 rounded-token-md focus:outline-none focus:ring-2 focus:ring-token-focus focus:ring-offset-token-focus transition-colors duration-200"
      aria-label="Promotions du site"
      title="Promotions du site"
    >
      <TagIcon className="h-6 w-6" />
    </button>
  );
}
